<template>
	<div>

		<header-nav :cur="0" />
		<!--    飘窗-->
<!--		<div class="window">-->
<!--			<div class="window_cont">-->
<!--				<a href="#"></a>-->
<!--				<a href="#"></a>-->
<!--			</div>-->
<!--		</div>-->
		<!-- 轮播 -->
		<div class="banner">
			<van-swipe class="my-swipe" :autoplay="3000" indicator-color="white" @change="onChange">
				<van-swipe-item v-for="(item, index) in swiper" :key="index">
					<img :src="item.img" alt="" />
				</van-swipe-item>
				<template #indicator>
					<div class="radio-box">
						<div v-for="(item, i) in swiper" :key="i" :class="[current == i ? 'check-radio' : 'radio']">
						</div>
					</div>
				</template>
			</van-swipe>
		</div>
		<!-- 行业资讯 -->
		<div>
			<div class="navtab" style="padding:0 0 20px 0;">
				<div class="navbox">
					<div class="navtop" v-for="(item, index) in navlist" :key="index"
						@mouseenter="navact(item.code,index)" :class="{ active: index == ind }">
						{{ item.name }}
						<img v-if="index == ind" src="../../assets/img/index/icon_more.svg" alt=""
							@click="toAllArticle()" />
						<img class="opc-hide" v-else src="../../assets/img/index/icon_more.svg" alt="" />
					</div>
				</div>
				<div>
					<div class="navbotbox">
						<div class="listnavbox" v-for="(obj, index1) in articleList.slice(0,6)" :key="index1"
							@click="toViewArticleDetail(obj.wid)">
							<div class="topbox">
								<div class="ignore right" style="cursor:pointer"  >{{ obj.articleTitle }}</div>
							</div>
							<div class="ignore bottom" style="cursor:pointer; display: none" v-text="obj.content"></div>
						</div>
					</div>
				</div>

			</div>
		</div>


		<div class="modular">
			  <a href="#" @click="toAllCoursePage('1',null)">
				<img src="../../assets/img/index/icon1.svg">
				<span>公需课</span>
			  </a>
			<a href="#" @click="toAllCoursePage('2','1')">
				<img src="../../assets/img/index/icon2.svg">
				<span>新闻传播</span>
			</a>
			<a href="#" @click="toAllCoursePage('2','2')">
				<img src="../../assets/img/index/icon3.svg">
				<span>文化旅游</span>
			</a>
			<a href="#" @click="toAllCoursePage('2','3')">
				<img src="../../assets/img/index/icon4.svg">
				<span>传媒艺术</span>
			</a>
			<a href="#" @click="toAllCoursePage('2','4')">
				<img src="../../assets/img/index/icon5.svg">
				<span>非遗传承</span>
			</a>
			<a href="#" @click="toAllCoursePage('2','5')">
				<img src="../../assets/img/index/icon6.svg">
				<span>电子电工</span>
			</a>
			<a href="#" @click="toAllCoursePage('2','6')">
				<img src="../../assets/img/index/icon7.svg">
				<span>化学化工</span>
			</a>
			<a href="#" @click="toAllCoursePage('2','7')">
				<img src="../../assets/img/index/icon8.svg">
				<span>经济学科</span>
			</a>
			<a href="#" @click="toAllCoursePage('2','8')">
				<img src="../../assets/img/index/icon9.svg">
				<span>其他类</span>
			</a>

		</div>

		<!-- 推荐课程 -->
		<div class="navtab">
			<div class="course">
				<img src="../../assets/img/index/icon_title.svg" alt="" />
				<span class="span1">推荐课程</span>
				<span class="span3" @click="toAllCoursePage(null,null)">更多&nbsp;></span>
			</div>
			<div class="courselist">
				<div class="courbox" v-for="(item, index) in courses" :key="index" @click="toCourseDetail(item.id)" style="cursor:pointer" >
					<div class="play">
						{{ item.credit }}学时
					</div>
					<div class="hour">{{ item.lessionNum }}章节</div>
					<img :src="$api.static_url+item.courseImage" alt="" width="221px" height="136px" />
					<div class="tit">{{ item.courseName }}</div>

				</div>
			</div>
		</div>

		<!-- 学习路径 -->
		<div class="navtab" style="margin-top: 30px;">
			<div class="course path">
				<img src="../../assets/img/index/icon_title.svg" alt="" />
				<span class="span1">学习路径</span>
				<span class="span3" @click="toAllClazzPage('4b16ce48-bbe5-4204-9dc4-351b3a3bf270')">更多&nbsp;></span>
			</div>
			<div class="line">
				<!-- <div class="circle"></div>
        <div class="cicline"></div> -->
				<div class="pathtop" v-for="(item, index) in ciline" :key="index">
					<img :src="item.img" alt="" />
					<div class="tit">{{ item.title }}</div>
				</div>
			</div>
		</div>
		<!-- 优秀讲师 -->
		<div class="navtab" style="margin-top: 70px;">
			<div class="course teach">
				<img src="../../assets/img/index/icon_title.svg" alt="" />
				<span class="span1">优秀讲师</span>
				<span class="span3" @click="toAllTeacherPage('4b16ce48-bbe5-4204-9dc4-351b3a3bf270')">更多&nbsp;></span>
			</div>
			<div class="teacher">
				<!-- <div class="wd_cont" style="margin: 0 auto;width: 100%;">
					<img src="../../assets/img/question/ts_iconn.svg"
						style="width: 12%;display: block;margin: 0 auto;" />
					<p style="width: 100%;text-align: center;margin-top: 20px;font-size: 28px;font-weight: bolder;">
						暂无教师数据,正在更新中...</p>
				</div> -->

				<div class="box" v-for="(teach, index) in teachers" :key="index">
					<div class="teachhead">
						<span><img :src="$api.static_url+teach.teacherImage" alt="" /></span>
					</div>
					<div class="teachright">
						<div class="namebox">
							<span class="name">{{ teach.teacherName }}</span>
							<span class="detal" :title="teach.introduction">{{ teach.introduction |jsFormat }}</span>
						</div>
						<div class="listbox">
							<div>
								<div class="div"></div>
								<div class="list">
									{{ teach.academic }}
								</div>
							</div>
							<div>
								<div class="div"></div>
								<div class="list">
									{{ teach.education }}
								</div>
							</div>
						</div>
					</div>
				</div>



		</div>
		</div>
		<!-- 底部 -->
		<footer-nav style="padding-top: 40px;" />
		<el-dialog
		  title="系统维护通知"
		  :visible.sync="dialogVisible"
		  width="700px"
		  :before-close="handleClose">
		  <!-- <span style="font-size: 20px;margin: 0 auto;">本平台2026年专业技术人员继续教育工作已开启。</span> -->
		  <br/>
		  <br/>
		
		  <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;尊敬的用户：当前系统正在进行维护，用户报名业务暂未恢复，敬请谅解，已成功报名的用户可正常开展学习。</div>
          <br />
		  <br />
		  <div style="float: right;margin-bottom: 60px;">兰州文理学院继续教育平台<br/>
2026年05月20日</div>
          <br />
          <br />
 
		  <span slot="footer" class="dialog-footer"  style="right: 0px;">
		    <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
		    <el-button type="primary" @click="dialogVisible = false" >关闭</el-button>
		  </span>
		</el-dialog>
	</div>
</template>
<script>
/* import QuillEditor from 'vue-quill-editor' */
import 'quill/dist/quill.snow.css'

	import {queryClazzReportState} from '@/api/user.js'

	import {
		queryCourseList,
		queryCourseById,
		queryFavoriteCourseList
	} from '@/api/course.js'
	import {
		queryArticleList,
		queryArticleById,
		latestArticleList
	} from '@/api/article.js'
	//
	import headerNav from '../../components/HeaderNav.vue';
	import footerNav from '../../components/FooterBar';
	import Vue from 'vue';
	import {
		Swipe,
		SwipeItem,
		Toast,
		DropdownMenu,
		DropdownItem
	} from 'vant';
	import ElementUI from 'element-ui';
import { Notification, MessageBox, Message, Loading } from 'element-ui';
	Vue.use(Swipe);
	Vue.use(SwipeItem);
	Vue.use(Toast);
	Vue.use(DropdownMenu);
	Vue.use(DropdownItem);
	export default {
		components: {
			headerNav,
			footerNav,
      //QuillEditor,
		},
		data() {
			return {
				dialogVisible: true,
				optindex: '',
				name: '请选择管理角色',
				show: false,
				aaa: '',
				current: 0,
				loginType: 0,
				//navlist: ['行业资讯', '培训动态', '通知公告'],
				navlist: [{
						name: '通知公告',
						code: 3
					},
					{
						name: '培训动态',
						code: 2
					},
					{
						name: '行业资讯',
						code: 1
					}
				],
				ind: 0,
				cou: '录播',
				option: ['领导', '校领导', '小小领导'],
				swiper: [{
						img: require('../../assets/img/banner.jpg')
					},
					{
						img: require('../../assets/img/banner.jpg')
					},
				],
				articleList: [],
				courses: '',
				teacher: [{
					img: require('../../assets/img/index/course.jpg'),
					name: '郭伟',
					detail: '首席课堂讲师',
					list1: '讲师所受课程名称等等',
					list2: '讲师所受课程名称',
				}, ],
				teachers: [],
				ciline: [{
						img: require('../../assets/img/index/xxlj_icon_1.svg'),
						title: '注册登录'
					},
					{
						img: require('../../assets/img/index/xxlj_icon_2.svg'),
						title: '报名缴费'
					},
					{
						img: require('../../assets/img/index/xxlj_icon_3.svg'),
						title: '网上学习'
					},
					{
						img: require('../../assets/img/index/xxlj_icon_4.svg'),
						title: '学满课时'
					},
					// {img: require('../../assets/img/index/xxlj_icon_5.svg'), title: '网上考试'},
					{
						img: require('../../assets/img/index/xxlj_icon_6.svg'),
						title: '打印证书'
					},
					{
						img: require('../../assets/img/index/xxlj_icon_7.svg'),
						title: '确认完成'
					},
				],
				codeUrl: this.$api.url + '/papi/CaptchaImage',
				baseUrl: this.$api.url + '/papi/CaptchaImage',
				code: '',
				password: '',
				loginName: '',
				loginstate: false,
				token: '',
				loading:false
			};
		},
		created() {

            this.queryCourse(1);
			this.queryTeachers();
			this.queryFrontArticleList(3);

		},
		filters: {
			jsFormat(describe) {
				return describe.substring(0, 50);
			}
		},
		methods: {
			handleClose(){
				this.dialogVisible = false;
			},
			queryCourse(courseType) {
				this.loading = true;
				var params = {
					'courseType': courseType,
					'pageNum': 1,
					'pageSize': 10
				}
				queryFavoriteCourseList(params).then(res => {
					if (res.code == 200) {
						this.courses = res.rows;
					} else {
						this.$message.error('查询课程错误');
					}
					this.loading =false;
				})

			},
			toCourseDetail(id) {
				var data = {
					id:id,
					year:localStorage.getItem('year')
				}
				queryClazzReportState(data).then(res => {
					var me = this;
					if(res.code == 200){
						if(res.state == '1'){
							me.$router.push({path:'/course/detail',query:{id:id}});
							return;
						}else{
							 me.$confirm('本课程您未报名，但您可以试看2分钟课程，也可直接前往个人中心报名学习!', '课程试学提示', {
							          distinguishCancelAndClose: true,
									  type:'warning ' ,
							          confirmButtonText: '试学',
							          cancelButtonText: '放弃'
							    }).then(() => {
									//跳转到试学
									me.$router.push({
										path: '/course/tryPlay',
										query: {
											courseId: id
										}
									});
							        //alert("试学！");
							    }).catch(action => {
							        console.log("取消所属")
							    });

							//me.$message.error(res.msg);
							//return;
						}
					}
				})
			},
			queryFrontArticleList(typeId) {
				var params = {
					'articleTypeId': typeId
				}
				queryArticleList(params).then(res => {
					//alert(res.rows.length);
					this.articleList = res.rows;
				})

			},
			toCareerAssessmentPage() {
				this.$router.push('/careerAssessment');
			},
			toAllTeacherPage() {
				this.$router.push('/teacher');
			},
			toAllClazzPage(id) {
				this.$router.push({
					path: '/clazz',
					query: {
						bid: id
					}
				});
			},

			toAllCoursePage(learningType,subjectId) {
				this.$router.push({path: '/course', query: {learningType: learningType,subjectId:subjectId}});
			},
			toAllArticle() {
				this.$router.push('/information');
			},
			toViewArticleDetail(id) {
				this.$router.push({
					path: 'information/detail',
					query: {
						id: id
					}
				});
			},
			getCode() {
				this.codeUrl = this.baseUrl + '?id=' + Math.ceil(Math.random() * 10);
			},

			queryTeachers() {
				this.$http.get(this.$api.url + '/papi/teacher/list', {
					params: {
						'pageNum': 1,
						'pageSize': 6
					}
				}).then((response) => {
					this.teachers = response.data.rows;
				}, (response) => {
					console.log("response" + response.data.rows.length);
				});
			},

			tomove(optindex) {
				this.optindex = optindex;
			},
			tooption(name) {
				this.name = name;
			},
			navact(type_code, index) {
				this.ind = index;
				this.queryFrontArticleList(type_code);
			},
			loginTypeFn(i) {
				this.loginType = i;
			},
			livesee(l) {
				this.cou = l;
				if (l == '直播') {
					this.queryCourse(2);
				} else {
					this.queryCourse(1);
				}
			},
			onChange(index) {
				this.current = index;
			},
			toshow() {
				this.show = !this.show;
			},
		},
	};
</script>


<style lang="less" scoped>
	.banner {
		position: relative;
	}

	.banner .logo {
		position: absolute;
		top: 75px;
		right: 320px;
		width: 282px;
		background: rgba(0, 0, 0, 0.6);
		padding: 20px;
		z-index: 1000;
	}

	.banner .logo .hr {
		height: 1px;
		background: rgba(255, 255, 255, 0.3);
		width: 100%;
		margin: 11px auto 26px;
	}

	.banner .logo .logtab .bus {
		font-size: 18px;
		color: #ffffff;
		cursor: pointer;
	}

	.banner .logo .logtab .stu {
		display: inline-block;
		margin-left: 10px;
	}

	.banner .logo .logtab .active {
		position: relative;
	}

	.banner .logo .logtab .active::after {
		content: '';
		width: 72px;
		height: 5px;
		background: #2961EF;
		position: absolute;
		bottom: -14px;
		left: 0;
	}

	.banner .logo .logtab .admin {
		display: inline-block;
		margin: 0 22px;
	}

	.banner .logo .logtab img {
		display: inline-block;
		float: right;
		margin-right: 10px;
	}

	.banner .logo .input {
		background: rgba(0, 0, 0, 0.2);
		width: 240px;
		height: 41px;
		margin: 0 auto;
		display: flex;
		align-items: center;
		border-radius: 6px;
	}

	.banner .logo .input .label {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 45px;
		height: 21px;
		border-right: 1px solid rgba(255, 255, 255, 0.5);
	}

	.banner .logo .input .label img {
		margin: auto;
	}

	.banner .logo .input input {
		background: none;
		border: none;
	}

	.banner .logo .input .code {
		background: #fff;
		width: 79px;
		height: 30px;
		border-radius: 5px;
		margin-right: 6px;
	}

	.banner .logo .sel {
		border: none;
		margin-bottom: 9px;
		font-size: 14px;
		font-weight: 300;
		color: #b7afa2;
		position: relative;
	}

	.banner .logo .sel .p {
		margin-left: 20px;
	}

	.banner .logo .sel img {
		width: 11px;
		height: auto;
		position: absolute;
		right: 30px;
		top: 17px;
	}

	.banner .logo .sel .innerbox {
		width: 100%;
		position: absolute;
		top: 41px;
		background: rgba(0, 0, 0, 0.9);
	}

	.banner .logo .sel .innerbox p {
		line-height: 50px;
		padding-left: 20px;
	}

	.banner .logo .sel .innerbox .activep {
		background: #fff;
	}

	.banner .logo .input-pass {
		margin-top: 9px;
	}

	.banner .logo .input-code {
		width: 110px;
	}

	.banner .logo .login-btn {
		cursor: pointer;
		display: flex;
		justify-content: center;
		align-items: center;
		width: 140px;
		height: 41px;
		background: #2961EF;
		border-radius: 21px;
		margin: 14px auto 15px;
	}

	.banner .logo .login-btn p {
		font-size: 16px;
		font-weight: 400;
		color: #ffffff;
	}

	.banner .logo .login-bottom {
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 14px;
		color: #ffffff;
	}

	.banner .logo .login-bottom .auto-login {
		display: flex;
		align-items: center;
	}

	.banner .logo .login-bottom input {
		width: 13px;
		height: 13px;
		margin-right: 4px;
	}

	.banner .logo .login-bottom .forgot-pwd {
		display: flex;
		align-items: center;
	}

	.banner .logo .login-bottom .forgot-pwd p {
		height: 14px;
		width: 1px;
		background-color: #fff;
		margin: 0 14px;
	}

	.banner .my-swipe {
		height: 506px;
	}

	.banner .my-swipe .van-swipe-item img {
		width: 100%;
		height: 100%;
		margin-top: -10px;
	}

	.banner .my-swipe .radio-box {
		position: absolute;
		right: 50%;
		bottom: 44px;
	}

	.banner .my-swipe .radio-box .check-radio {
		display: inline-block;
		width: 37px;
		height: 13px;
		background: #ffffff;
		border-radius: 9px 9px 9px 9px;
		margin: 10px;
	}

	.banner .my-swipe .radio-box .radio {
		display: inline-block;
		width: 13px;
		height: 13px;
		background: #ffffff;
		border-radius: 50%;
		opacity: 0.6;
		margin: 10px;
	}

	.navtab {
		width: 1280px;
		margin: 0 auto;
	}

	.color {
		color: #2961EF !important;
	}

	.ignore {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
	}

	.navbox {
		display: flex;
		justify-content: center;
		margin: 30px 0 10px 0;
	}

	.navbox .navtop {
		font-size: 20px;
		padding: 10px 0;
		width: 130px;
		color: #383838;
		text-align: center;
		margin: 10px;
		cursor: pointer;
	}

	.navbox .navtop img {
		width: 20px;
		height: 20px;
	}

	.navbox .navtop .opc-hide {
		opacity: 0;
	}

	.navbox .active {
		color: #2961EF;
		border-bottom: 5px solid #2961EF;
    display: flex;
    justify-content: center;
    align-items: center;
	}

  .navbox .active img{
    margin-left: 6px;
    transform: translateY(1px);
  }

	.navbotbox {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
	}

	.navbotbox .listnavbox {
		width: 32%;
    height: auto;
    background: #fafafa;
    border: 1px solid #f1f1f1;
    box-shadow: 0 3px 6px rgba(0,0,0,.05);
    border-radius: 6px;
    padding:15px 25px;
    box-sizing: border-box;
		margin-bottom: 33px;
	}

	.navbotbox .listnavbox .topbox {
		position: relative;
		display: flex;
	}

	.navbotbox .listnavbox .topbox .topclass {
		margin-top: -18px;
	}

	.navbotbox .listnavbox .topbox .topclass .num {
		font-size: 47px;
	}

	.navbotbox .listnavbox .topbox .topclass .data {
		font-size: 11px;
		margin-top: -14px;
	}

	.navbotbox .listnavbox .topbox .right {
		font-size: 16px;
		line-height: 26px;
	}



	.navbotbox .listnavbox .bottom {
		font-size: 13px;
		font-weight: 300;
		color: #bebebe;
		width: calc(90% - 30px);
    padding-left: 15px;
    padding-right: 15px;
    margin-right: 0;
		text-indent: 2em;
		padding-bottom: 30px;
		border-bottom: 1px dashed rgba(112, 112, 112, 0.3);
	}

	.navbotbox .listnavbox:nth-child(3n) .topbox::after {
		border-right: none;
	}

	.navbotbox .listnavbox:nth-child(1n + 4) .bottom {
		border-bottom: none;
	}

	.backg {
		background: #f7f8fa;
		display: flex;
	}

	.backg .box {
		flex: 1;
		padding: 23px 25px 24px 31px;
		border-right: 1px solid rgba(216, 219, 225, 0.4);
	}

	.backg .box:last-child {
		border: none;
	}

	.backg .box img {
		width: 10%;
		height: auto;
		display: inline-block;
		vertical-align: top;
		margin-right: 11px;
	}

	.backg .box .type {
		display: inline-block;
		width: 224px;
		overflow: hidden;
	}

	.backg .box .type .typetitle {
		font-size: 19px;
		color: #333333;
	}

	.backg .box .type ul {
		margin-left: -10px;
		height: 43px;
		overflow: hidden;
	}

	.backg .box .type ul li {
		display: inline-block;
		border-right: 1px solid rgba(51, 51, 51, 0.6);
		font-size: 14px;
		color: rgba(51, 51, 51, 0.6);
		line-height: 13px;
		padding: 0 10px;
		margin: 5px 0;
	}

	.backg .box .type ul li:last-child {
		border-right: none;
	}

	.course {
		margin-top: 52px;
	}

	.course img {
		vertical-align: middle;
	}

	.course .span1 {
		vertical-align: middle;
		font-size: 20px;
		color: #000000;
		margin: 0 21px 0 10px;
	}

	.course .span2 {
		vertical-align: middle;
		font-size: 14px;
		color: #000000;
		margin: 0 21px 0 5px;
		cursor: pointer;
	}

	.course .span3 {
		cursor: pointer;
		vertical-align: middle;
		float: right;
		font-size: 14px;
		color: #6a6a6a;
	}

	.courselist {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		margin-top: 22px;
	}

	.courselist .courbox {
		border-radius: 5px 5px 5px 5px;
		border: 1px solid #f1f1f1;
		padding: 10px 10px 0;
		width: 17.4%;
		margin-bottom: 18px;
		position: relative;
		margin-right: 1%;
	}

	.courselist .courbox:nth-child(5n) {
		margin-right: 0;
	}

	.courselist .courbox .play {
		position: absolute;
		top: 15px;
		left: 15px;
		background: rgba(255, 106, 0, 0.8);
		border-radius: 5px 5px 5px 5px;
		padding: 3px 10px;
		font-size: 14px;
		color: #ffffff;
	}

	.courselist .courbox .play img {
		margin-right: 5px;
	}

	.courselist .courbox .hour {
		position: absolute;
		top: 15px;
		right: 15px;
		background: rgba(255, 106, 0, 0.8);
		border-radius: 5px 5px 5px 5px;
		padding: 3px 10px;
		font-size: 14px;
		color: #ffffff;
	}

	.courselist .courbox .tit {
		font-size: 14px;
		color: #383838;
		margin-bottom: 5px;
	}

	.courselist .courbox .bottom {
		height: 40px;
		border-top: 1px solid #f1f1f1;
	}

	.courselist .courbox .bottom img {
		vertical-align: middle;
		width: 21px;
		height: 21px;
		border-radius: 50%;
	}

	.courselist .courbox .bottom .person {
		vertical-align: middle;
		line-height: 41px;
		padding: 0 15px 0 10px;
		font-size: 14px;
		color: #888888;
	}

	.courselist .courbox .bottom .person::after {
		content: '';
		border: 1px solid rgba(112, 112, 112, 0.3);
		height: 2px;
		margin-left: 10px;
	}

	.courselist .courbox .bottom .num {
		vertical-align: middle;
		line-height: 41px;
		font-size: 14px;
		color: #888888;
	}

	.courselist .courbox .bottom .money {
		vertical-align: middle;
		line-height: 41px;
		font-size: 14px;
		color: #2961EF;
		float: right;
	}

	.path {
		margin-top: 20px;
	}

	.line {
		width: 85%;
		margin: 0 auto;
		position: relative;
		border-bottom: 1px dashed #707070;
		margin-top: 180px;
	}

	.line .pathtop {
		background: url(../../assets/img/index/xxlj_bg.svg) no-repeat;
		background-size: 100% 100%;
		width: 110px;
		height: 167px;
		top: -151px;
	}

	.line .pathtop:after {
		content: "";
		position: absolute;
		width: 1.11111rem;
		height: 0.55556rem;
		top: 34%;
		left: 115%;
		background: url(../../assets/img/xxl.svg) no-repeat;
	}

	.line .pathtop:nth-child(6):after {
		content: "";
		position: absolute;
		width: 1.11111rem;
		height: 0.55556rem;
		top: 34%;
		left: 115%;
		background: none;
	}

	.line .pathtop img {
		margin: 30px 35% 5px;
		width: 25%;
		height: auto;
	}

	.line .pathtop .tit {
		width: 66px;
		text-align: center;
		font-size: 16px;
		font-weight: 300;
		color: rgba(255, 255, 255, 0.8);
		margin-left: 15%;
		border-top: 1px solid rgba(255, 255, 255, 0.7);
		margin: 0 auto;
		padding-top: 5px;
	}

	.line .pathtop:nth-child(1) {
		position: absolute;
		left: 0px;
	}

	.line .pathtop:nth-child(2) {
		position: absolute;
		left: 192px;
	}

	.line .pathtop:nth-child(3) {
		position: absolute;
		left: 385px;
	}

	.line .pathtop:nth-child(4) {
		position: absolute;
		left: 578px;
	}

	.line .pathtop:nth-child(5) {
		position: absolute;
		left: 771px;
	}

	.line .pathtop:nth-child(6) {
		position: absolute;
		left: 964px;
	}

	.line .pathtop:nth-child(7) {
		position: absolute;
		left: 1159px;
	}

	.teach {
		margin-top: 35px;
		margin-bottom: 35px;
	}

	.teacher {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
	}

	.teacher .box {
		position: relative;
		width: 32%;
		margin-bottom: 31px;
	}

	.teacher .box .teachhead {
		position: absolute;
		top: 0;
		left: 10px;
		display: inline-block;
		width: 112px;
		height: 112px;
		box-shadow: 0px 7px 10px 1px rgba(41, 97, 239, 0.2);
		opacity: 1;
		border: 1px solid #2961EF;
		border-radius: 50%;
	}

	.teacher .box .teachhead img {
		width: 112px;
		height: 112px;
		border-radius: 50%;
	}

	.teacher .box .teachright {
		display: inline-block;
	}

	.teacher .box .teachright .namebox {
		margin-left: 150px;
		margin-top: 23px;
		margin-bottom: 13px;
	}

	.teacher .box .teachright .namebox .name {
		font-size: 17px;
		color: #333333;
		margin-right: 16px;
	}

	.teacher .box .teachright .namebox .detal {
		font-size: 12px;
		color: #2961EF;
	}

	.teacher .box .teachright .listbox {
		background: #f7f8fa;
		border-radius: 40px 0px 40px 0px;
		width: 250px;
		padding: 15px 15px 15px 150px;
	}

	.teacher .box .teachright .listbox .div {
		display: inline-block;
		width: 5px;
		height: 5px;
		border-radius: 50%;
		border: 1px solid #2961EF;
		margin-right: 10px;
		vertical-align: middle;
	}

	.teacher .box .teachright .listbox .list {
		vertical-align: middle;
		display: inline-block;
		font-size: 14px;
		line-height: 30px;
		color: #333333;
	}

	.hyzx {
		width: 1280px;
		height: auto;
		display: block;
		margin: 0 auto;
	}

	.banner {
		width: 100%;
		height: auto;
	}

	.banner img {
		width: 100%;
		height: auto;
	}

	.modular {
		width: 1280px;
		height: 110px;
		margin: 0 auto;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.modular a {
		width: 100%;
		height: auto;
    padding:20px 0;
		background-size: auto 100%;
		border-radius: 6px;
		overflow: hidden;
		display: flex;
		align-items: center;
		justify-content: center;
    flex-flow: column;
    margin-right: 15px;
    &:last-child{
      margin-right: 0;
    }
    img{
      height: 46px;
      margin-bottom: 5px;
    }

	}

	.modular a span {
		width: auto;
		font-size: 18px;
		color: #fff;
	}

	.modular a:nth-child(1) {
		background: url("../../assets/img/index/modular_1.jpg") no-repeat center 0;
	}

	.modular a:nth-child(2) {
		background: url("../../assets/img/index/modular_2.jpg") no-repeat center 0;
	}

	.modular a:nth-child(3) {
		background: url("../../assets/img/index/modular_3.jpg") no-repeat center 0;
	}

	.modular a:nth-child(4) {
		background: url("../../assets/img/index/modular_4.jpg") no-repeat center 0;
	}

  .modular a:nth-child(5) {
    background: url("../../assets/img/index/modular_5.jpg") no-repeat center 0;
  }

  .modular a:nth-child(6) {
    background: url("../../assets/img/index/modular_1.jpg") no-repeat center 0;
  }

  .modular a:nth-child(7) {
    background: url("../../assets/img/index/modular_2.jpg") no-repeat center 0;
  }

  .modular a:nth-child(8) {
    background: url("../../assets/img/index/modular_3.jpg") no-repeat center 0;
  }

  .modular a:nth-child(9) {
    background: url("../../assets/img/index/modular_4.jpg") no-repeat center 0;
  }

  .modular a:hover {
		box-shadow: 0 0 10px 0 #ccc;
	}

	//飘窗
	.window {
		width: 1200px;
		height: 1px;
		left: 50%;
		text-align: center;
		position: fixed;
		top: 0;
		margin-left: -606px;
		z-index: 999999;
	}

	.window .window_cont {
		width: 120px;
		height: auto;
		position: absolute;
		top: 200px;
		right: -180px;
	}

	.window .window_cont a {
		width: 120px;
		height: 120px;
		margin-top: 10px;
		display: block;
	}

	.window .window_cont a img {
		width: 120px;
		height: 120px;
		display: block;
	}


</style>
